import * as React from 'react';

function SvgCloudDisconnectColored(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 107 82.3" {...props}>
      <g strokeWidth={3} strokeMiterlimit={10}>
        <path
          d="M105.5 44c0-11.3-9.6-20.5-21.5-20.5-3.7 0-7.4.9-10.6 2.7.1-.7.1-1.4.1-2.2 0-12.4-10.1-22.5-22.6-22.4-11.2 0-20.7 8.4-22.2 19.5-5.5 1.7-9.2 6.7-9.2 12.4v1H19c-9.7 0-17.5 6.7-17.5 15s7.8 15 17.5 15h65.5c11.6-.3 21-9.3 21-20.5z"
          fill="#cacbcd"
          stroke="#cacbcd"
        />
        <path
          fill="#fa0600"
          stroke="#fa0600"
          d="M74.7 44.4l-7.1-7.1-14.3 14.4-13.9-13.9-7.1 7.1 13.9 13.9-13.9 13.8 7.1 7.1 13.9-13.9 14.3 14.4 7.1-7.1-14.4-14.3z"
        />
      </g>
    </svg>
  );
}

export default SvgCloudDisconnectColored;
